import { Component, ViewChild, TemplateRef, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Logger } from '@se/se.ui.html5';
import { Subscription, Subject } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntil } from 'rxjs/operators';
import { AutoUnsubscribe, EstensaBusWrapperService, TooluploadState, seOpenTooluploadDialog, UploadExternalData } from '@se/platform';
import { OriginPage,  } from '../../models';
import EstensaModel from 'estensa-module';
import { PatientDetails } from '../dicom/models/dto/patient-details';

@Component({
    selector: 'toolupload-dialog',
    templateUrl: './toolupload-dialog.component.html',
    styleUrls: ['./toolupload-dialog.component.scss'],
})
export class TooluploadDialogComponent implements OnInit, OnDestroy {

    @ViewChild('tooluploadDialogTemplate')
    tooluploadDialogTemplate: TemplateRef<any>;

    private seVnaDialog: MatDialogRef<any>;
    patientDetails: PatientDetails = null;
    vnaUploadExternalData: UploadExternalData = null;
    updatedPatient: EstensaModel.Patient = null;
    private actionsSubscription!: Subscription;

    private ngUnsubscribe: Subject<void> = new Subject<void>();

    // constructor

    constructor(public dialog: MatDialog,
            private actions: Actions,
            private estensaBusWrapperService: EstensaBusWrapperService,
            private logger: Logger
    ) {
    }

    public ngOnInit() {
        this.listenForStoreEvents();
    }

    @AutoUnsubscribe()
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        if (this.actionsSubscription)
            this.actionsSubscription.unsubscribe();
    }


    private listenForStoreEvents() {
        this.actionsSubscription = this.actions
            .pipe(
                takeUntil(this.ngUnsubscribe),
                ofType(seOpenTooluploadDialog)
            )
            .subscribe({
                next: (data: TooluploadState) => {
                    this.vnaUploadExternalData = data.data;
                    if (this.vnaUploadExternalData.type) {
                        this.patientDetails = this.getPatientDetails(this.vnaUploadExternalData);
                        this.openDicomDialog();
                    } else {
                        this.openNotDicomDialog();
                    } 
                },
                error: () => {
                    this.logger.error('no data retrieved')
                }
            });
    }

    // #region Dialog

    private openDicomDialog() {
        this.seVnaDialog = this.dialog.open(this.tooluploadDialogTemplate, {
            autoFocus: true,
            maxHeight: '640px',
            disableClose: true
        })
    }

    openNotDicomDialog() {
        this.seVnaDialog = this.dialog.open(this.tooluploadDialogTemplate, {
            autoFocus: true,
            height: '95%',
            width: '80%',
            minWidth: '700px',
            minHeight: '500px',
            disableClose: true
        }) 
    }

    closeModal() {
        this.seVnaDialog.close(true);
        if (this.vnaUploadExternalData.from === OriginPage.VNA_PATIENT_FOLDER && !this.vnaUploadExternalData.type) {
            this.estensaBusWrapperService.notify({ messageType: "CLOSE_MODAL_TOOLUPLOAD", data: { patient: this.vnaUploadExternalData.selectedPatient } })
        }
        if (this.vnaUploadExternalData.from === OriginPage.VNA_PATIENT_FOLDER && this.vnaUploadExternalData.type) {
            this.estensaBusWrapperService.notify({ messageType: "CLOSE_MODAL_TOOLUPLOAD", data: { patientId: this.vnaUploadExternalData.selection.identifier } })
        }
    }

    // #endregion

    // #region Get/Set Data

    getPatientDetails(data: UploadExternalData): PatientDetails {
        if (data) {
            const patientDetails: PatientDetails = this.setData();
            return patientDetails;
        } else {
            this.logger.error('patient details data error')
            return {
                Issuer: '',
                PatientId: '',
                Name: '',
                Surname: '',
                Sex: '',
                BirthDate: '',
                AccessionNumber: ''
            };
        }
        
    }

    private setData () : PatientDetails {
        return {
            Issuer: this.vnaUploadExternalData.selection?.issuer,
            PatientId: this.vnaUploadExternalData.selection?.identifier,
            Name: this.vnaUploadExternalData.selection?.firstName,
            Surname: this.vnaUploadExternalData.selection?.lastName,
            Sex: this.vnaUploadExternalData.selection?.sexCode,
            BirthDate: this.vnaUploadExternalData.selection?.birthDate,
            AccessionNumber: this.vnaUploadExternalData.selection?.accessionNumber
        };
    }

    // #endregion
}
